<div class="line-chart-container w-100 h-100" [class.chart-container]="!noAgentsSelected">
    <ng-container *ngIf="!noAgentsSelected; then chartData else noData"></ng-container>
</div>

<ng-template #chartData>
    <div class="canvas-chart w-100 p-1">
        <canvas baseChart *ngIf="chartConfig" [type]="chartConfig.type"
            [legend]="chartConfig.options.plugins.legend.display" [datasets]="chartConfig.data.datasets"
            [labels]="chartConfig.data.labels" [options]="chartConfig.options" [plugins]="chartConfig.plugins"
            (mouseout)="onMouseOut($event)">
        </canvas>
    </div>
</ng-template>

<ng-template #noData>
    <div class="no-data-container">
        <svg>
            <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
        </svg>
        <span class="info" cvLocalizedText langSection="Evaluator_Performance" langKey="No_Evaluators">
            No evaluators selected yet
        </span>
    </div>
</ng-template>